class CompleteTheLook extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)
      // complementary vs related
      fetch(
        `${this.baseUrl}?section_id=${this.sectionId}&product_id=${this.productId}&limit=${this.limit}&intent=${this.mode}`,
      )
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('complete-the-look')

          const productsFound = parseInt(
            recommendations.dataset.productsFound,
            10,
          )

          if (productsFound > 0) {
            this.innerHTML = recommendations.innerHTML
            window.dispatchEvent(new Event('resize'))

            const container = this.querySelector(
              '[data-complete-the-look-el="container"]',
            )
            if (container) {
              container.setAttribute('aria-hidden', 'false')
            }
          }
        })
        .catch((e) => {
          console.error(e)
        })
    }
    /* eslint-disable-next-line compat/compat */
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 500px 0px',
    }).observe(this)
  }

  get baseUrl () {
    return this.dataset.baseUrl
  }

  get limit () {
    return this.dataset.limit
  }

  get mode () {
    return this.dataset.mode
  }

  get productId () {
    return this.dataset.productId
  }

  get sectionId () {
    return this.dataset.sectionId
  }
}

if (!customElements.get('complete-the-look')) {
  customElements.define('complete-the-look', CompleteTheLook)
}
